<template>
  <div class="media-list">
    <breadcrumb main-name="预播设备"
                :breadcrumbList="breadcrumbList"></breadcrumb>
    <div class="readyplay_list">
      <span @click="toBack()">返回</span>
    </div>
    <div style="padding: 24px">
      <div class="select-box">
        <div id="components-form-demo-advanced-search">
          <a-row :gutter="24">
            <a-col :span="8">
              <span class="form-label">所在区域：</span>
              <a-cascader :options="citySource"
                          v-model="filterParams.city"
                          @change="filterCity"
                          changeOnSelect
                          placeholder="请选择所在区域" />
            </a-col>
            <a-col :span="8">
              <span class="form-label">小区名称：</span>
              <a-input v-model="filterParams.communityName"
                       placeholder="请输入所属小区" />
            </a-col>
            <a-col :span="8">
              <a-button type="primary"
                        html-type="submit"
                        @click="handleSearch">
                查询
              </a-button>
              <a-button :style="{ marginLeft: '8px' }"
                        @click="handleReset">
                重置
              </a-button>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="table-wrap">
        <a-table :columns="columns"
                 :dataSource="mediaList"
                 :pagination="false"
                 :scroll="{ x: 1550 }"
                 @change="columnsFilter">
          <div slot="filterInput"
               slot-scope="{setSelectedKeys, selectedKeys,confirm, clearFilters, column }"
               style="padding: 8px">
            <a-input :placeholder="`搜索 ${column.title}`"
                     :value="selectedKeys[0]"
                     @change="e => setSelectedKeys(e.target.value ? [e.target.value] : '')"
                     @pressEnter="() => headerSearch(selectedKeys,confirm,column,clearFilters)"
                     style="width: 152px; margin-bottom: 8px; display: block;" />
            <a-button type="primary"
                      @click="() => headerSearch(selectedKeys,confirm,column,clearFilters)"
                      icon="search"
                      size="small"
                      style="width: 74px; margin-right: 8px">搜索</a-button>
            <a-button @click="() => headerReset(clearFilters)"
                      size="small"
                      style="width: 74px">重置</a-button>
          </div>
          <a-icon slot="filterIcon"
                  slot-scope="filtered"
                  type="search"
                  :style="{ color: filtered ? '#108ee9' : undefined }" />
          <template slot="MAC"
                    slot-scope="row">
            <router-link :to="{ path: '/mediaDetail', query: { pointId: row.pointId }}">{{row.MAC}}
            </router-link>
          </template>
          <template slot="mediaStatus"
                    slot-scope="mediaStatus">
            <span v-if="mediaStatus == 1">
              <a-badge status="success" />正常
            </span>
            <span v-else>
              <a-badge status="warning" />异常
            </span>
          </template>
          <template slot="devOnlineStatus"
                    slot-scope="devOnlineStatus">
            <span v-if="devOnlineStatus == 1">
              <a-badge status="success" />激活
            </span>
            <span v-if="devOnlineStatus == 2">
              <a-badge status="processing" />上线
            </span>
            <span v-if="devOnlineStatus == 3">
              <a-badge status="warning" />故障
            </span>
            <span v-if="devOnlineStatus == -999">
              <a-badge status="error" />禁用
            </span>
            <span v-if="devOnlineStatus == 0">
              <a-badge status="default" />待安装
            </span>
            <span v-if="devOnlineStatus == '---'"> ---</span>
          </template>
          <template slot="action"
                    slot-scope="action">
            <a-dropdown placement="bottomCenter">
              <a class="ant-dropdown-link"
                 href="javascript:;">
                操作
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay"
                      @click="handleRow($event,action)">
                <a-menu-item key="1">播放列表</a-menu-item>
                <a-menu-item key="2">物料更新记录</a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table>
        <div class="page-wrap">
          <a-pagination :pageSizeOptions="pageSizeOptions"
                        :total="total"
                        showSizeChanger
                        showQuickJumper
                        :pageSize="pageSize"
                        v-model="current"
                        @showSizeChange="onShowSizeChange"
                        @change="changePage">
          </a-pagination>
        </div>
      </div>
      <!--播放列表-->
      <a-modal title="播放列表"
               v-model="playListModal"
               width="50%">
        <a-table :columns="playColumns"
                 :dataSource="playList">
          <template slot="planName"
                    slot-scope="row">
            <a href="javascript:;"
               @click="goPlanDetail(row)">{{row.planName}}</a>
          </template>
          <template slot="action"
                    slot-scope="row">
            <a href="javascript:;"
               @click="showMaterial(row)">查看物料</a>
          </template>
        </a-table>
        <template slot="footer">
          <a-button @click="playListModal = false">关闭</a-button>
        </template>
      </a-modal>
      <!--物料更新记录-->
      <a-modal title="物料更新记录"
               v-model="materialUpdateModal"
               width="50%">
        <a-table :columns="materialColumns"
                 :dataSource="materialList"
                 :pagination="false">
          <template slot="packageVersion"
                    slot-scope="row">
            <a href="javascript:;"
               @click="showPackageList(row)">{{row.packageVersion}}</a>
          </template>
        </a-table>
        <div class="page-wrap">
          <a-pagination size="small"
                        :total="updateTotal"
                        v-model="updatePageNum"
                        @change="changeUpdatePage">
          </a-pagination>
        </div>
        <template slot="footer">
          <a-button @click="materialUpdateModal = false">关闭</a-button>
        </template>
      </a-modal>
      <!--广告包列表-->
      <a-modal class="play-modal"
               :title="packageList.title"
               v-model="packageModal"
               width="60%">
        <div>
          <div class="radio-wrap">
            <a-radio-group :value="packageList.type"
                           @change="value => chooseAdType(value, 'package')"
                           buttonStyle="solid">
              <a-radio-button value="1">轮播广告</a-radio-button>
              <a-radio-button value="2">精准广告</a-radio-button>
            </a-radio-group>
          </div>
          <a-table :columns="packageList.columns"
                   :dataSource="packageList.list"
                   :pagination="false">
            <template slot="planName"
                      slot-scope="row">
              <a href="javascript:;"
                 @click="goPlanDetail(row)">{{row.planName}}</a>
            </template>
            <template slot="action"
                      slot-scope="row">
              <a href="javascript:;"
                 @click="showMaterial(row)">查看物料</a>
            </template>
          </a-table>
        </div>
        <template slot="footer">
          <a-button @click="packageModal = false">关闭</a-button>
        </template>
      </a-modal>
      <!--查看物料-->
      <a-modal v-model="materialModal"
               :footer="null"
               width="450px">
        <div class="material-box"
             v-if="materialInfo.playType==2">
          <div v-for="(item,index) in materialInfo.materialDetailsList"
               :key="index"
               class="img-mask"
               :class="item.adSpace==2?'video-mask':''">
            <img v-if="item.fileType==1"
                 :src="item.fileUrl"
                 alt="">
            <video v-if="item.fileType==3"
                   :src="item.fileUrl"
                   autoplay="autoplay"
                   loop="loop"
                   controls></video>
          </div>
        </div>
        <div class="material-box full-screen-mask"
             v-else>
          <div class="img-mask"
               v-if="materialInfo.materialDetailsList.length>0">
            <img v-if="materialInfo.materialDetailsList[0].fileType==1"
                 :src="materialInfo.materialDetailsList[0].fileUrl"
                 alt="">
            <video v-else
                   :src="materialInfo.materialDetailsList[0].fileUrl"
                   autoplay="autoplay"
                   loop="loop"
                   controls></video>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../common/Breadcrumb.vue'
import api from '../../commomFun/api.js'
import timeFormat from '../../commomFun/timeFormat';

export default {
  name: 'HelloWorld',
  components: {
    breadcrumb
  },
  data () {
    return {
      // 面包屑
      breadcrumbList: [
        {
          name: '点位管理',
          path: '/mediaList'
        }
      ],
      // 过滤参数
      filterParams: {
        deviceName: '',
        deviceCode: '',
        city: [],
        communityName: '',
        MAC: '',
        devStatus: null,
      },
      citySource: [],
      mediaList: [],
      pageSizeOptions: ['10', '20', '30', '40'],
      current: 1,
      pageSize: 10,
      total: 0,
      adType: '1',
      //播放列表
      playListModal: false,
      playColumns: [
        {
          title: '计划名称',
          key: 'planName',
          scopedSlots: { customRender: 'planName' },
        }, {
          title: '开始时间',
          dataIndex: 'beginTime',
          key: 'beginTime'
        }, {
          title: '结束时间',
          dataIndex: 'endTime',
          key: 'endTime'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }],
      playList: [{
        key: '1',
        planName: '',
        beginTime: '',
        endTime: '',
      }],
      //物料更新记录
      materialUpdateModal: false,
      materialModal: false,
      updateTotal: 0,
      updatePageNum: 1,
      materialColumns: [
        {
          dataIndex: 'type',
          title: '类型',
          key: 'type',
        },
        {
          title: '广告包版本',
          key: 'packageVersion',
          scopedSlots: { customRender: 'packageVersion' },
        }, {
          title: '物料更新时间',
          dataIndex: 'updateTime',
          key: 'updateTime'
        }],
      materialList: [],
      //查看物料
      materialInfo: {
        playType: 1,
        materialDetailsList: [
          {
            fileType: 1,//1-图片 3-视频
            fileUrl: '../../../public/images/a-1.png',
            playDuration: '',//上传物料视频时长
            playForm: '',//上传物料播放形式
          },
        ]
      },
      //广告包
      packageModal: false,
      packageList: {
        title: '',
        type: '1',
        list: [],
        columns: [
          {
            title: '计划名称',
            key: 'planName',
            scopedSlots: { customRender: 'planName' },
          }, {
            title: '开始时间',
            dataIndex: 'beginTime',
            key: 'beginTime'
          }, {
            title: '结束时间',
            dataIndex: 'endTime',
            key: 'endTime'
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' }
          }]
      },
      // 头部自定义过滤
      filteredSelect: null,
      filrterkeyword: {
        MAC: '',
        deviceName: '',
        deviceCode: '',
      },
      clearFilters: [],
    }
  },
  computed: {
    columns () {
      let { filteredSelect, filrterkeyword } = this;
      filteredSelect = filteredSelect || {};
      filrterkeyword = filrterkeyword;
      // 表头
      const columns = [
        {
          title: 'MAC',
          key: 'MAC',
          scopedSlots: {
            filterDropdown: 'filterInput',
            filterIcon: 'filterIcon',
            filteredValue: filrterkeyword.MAC || null,
            customRender: 'MAC',
          },
        },
        {
          title: '点位名称',
          dataIndex: 'deviceName',
          key: 'deviceName',
          width: 140,
          scopedSlots: {
            filterDropdown: 'filterInput',
            filterIcon: 'filterIcon',
            filteredValue: filrterkeyword.deviceName || null,
            customRender: 'deviceName',
          },
        },
        {
          title: '设备编码',
          dataIndex: 'deviceCode',
          key: 'deviceCode',
          width: 120,
          scopedSlots: {
            filterDropdown: 'filterInput',
            filterIcon: 'filterIcon',
            filteredValue: filrterkeyword.deviceCode || null,
            customRender: 'deviceCode',
          },
        },
        {
          title: '门名称',
          dataIndex: 'doorName',
          key: 'doorName',
          width: 130
        },
        {
          title: '终端型号',
          dataIndex: 'TerminalType',
          key: 'TerminalType',
          width: 110,
        },
        {
          title: '所属城市',
          key: 'city',
          dataIndex: 'city',
          width: 130
        },
        {
          title: '区/县',
          key: 'area',
          dataIndex: 'area',
          width: 110
        },
        {
          title: '所属小区',
          key: 'communityName',
          dataIndex: 'communityName',
          width: 150,
        },
        {
          title: '所属公司',
          key: 'companyName',
          dataIndex: 'companyName',
          width: 210,
        },
        {
          title: '设备状态',
          key: 'devOnlineStatus',
          dataIndex: 'devOnlineStatus',
          width: 110,
          fixed: 'right',
          filters: [
            { text: '全部', value: 'all' },
            { text: '激活', value: '1' },
            { text: '上线', value: '2' },
            { text: '故障', value: '3' },
            { text: '禁用', value: '-999' },
            { text: '待安装', value: '0' }
          ],
          filteredValue: filteredSelect.devOnlineStatus || null,
          filterMultiple: false,
          scopedSlots: { customRender: 'devOnlineStatus' }
        },
        {
          title: '媒体状态',
          key: 'mediaStatus',
          dataIndex: 'mediaStatus',
          scopedSlots: { customRender: 'mediaStatus' },
          width: 110,
          fixed: 'right',
          filters: [
            { text: '全部', value: '3' },
            { text: '正常', value: '1' },
            { text: '异常', value: '0' },
          ],
          filteredValue: filteredSelect.mediaStatus || null,
          filterMultiple: false,
        },
        {
          title: '操作',
          key: 'action',
          width: 90,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ];
      return columns;
    }
  },
  mounted () {
    this.getCityList()
    this.getMediaList()
  },
  methods: {
    columnsFilter (pagination, filters) {
      console.log('----parameters', pagination, filters)
      this.filteredSelect = filters;
      for (let i in filters) {
        let value = filters[i] ? filters[i][0] : '';
        if (i === 'devOnlineStatus') {
          console.log('---', filters[i]);
          this.filterParams.devOnlineStatus = value;
        } else if (i === 'mediaStatus') {
          this.filterParams.devStatus = value;
        } else if (i === 'MAC') {
          this.filterParams.MAC = value;
        } else if (i === 'deviceName') {
          this.filterParams.deviceName = value;
        } else if (i === 'deviceCode') {
          this.filterParams.deviceCode = value;
        }
      }
      this.getMediaList()
    },
    // 跳转到媒体列表
    toBack () {
      this.$router.push('./mediaList');
    },
    //查询
    handleSearch () {
      this.current = 1
      this.getMediaList()
    },
    //重置
    handleReset () {
      let obj = {
        deviceName: '',
        deviceCode: '',
        city: [],
        communityName: '',
        MAC: '',
        devStatus: undefined,
        devOnlineStatus: undefined
      };
      this.filterParams = obj;
      // 头部filter状态清空
      this.filteredSelect = null;
      this.filrterkeyword.MAC = ''
      for (let key of this.clearFilters) {
        key()
      }
      this.clearFilters = []
      // 分页
      this.current = 1
      this.getMediaList()
    },
    // 头部过滤确认
    headerSearch (selectedKeys, confirm, column, clearFilter) {
      this.clearFilters.push(clearFilter)
      confirm()
    },
    // 头部过滤取消
    headerReset (clearFilters) {
      clearFilters();
    },
    //跳至
    changePage (page, pageSize) {
      // console.log(page, pageSize);
      this.pageSize = pageSize;
      this.current = page;
      this.getMediaList()
    },
    //物料更新记录页码
    changeUpdatePage (current) {
      this.updatePageNum = current
      this.GetMaterialUpdateList()
    },
    onShowSizeChange (current, pageSize) {
      // console.log(current, pageSize);
      this.pageSize = pageSize;
      this.getMediaList()
    },
    //城市模糊筛选
    filterCity (input, option) {
      return option.componentOptions.children[0].text.indexOf(input) >= 0
    },
    //列表操作
    handleRow (item, action) {
      console.log(item.key, action);
      this.pointId = action.pointId
      if (item.key == 1) {
        //播放列表
        this.playListModal = true;
        this.getPlayList()
      } else if (item.key == 2) {
        this.materialUpdateModal = true;
        this.GetMaterialUpdateList()
      }
    },
    //跳转详情
    goPlanDetail (row) {
      // console.log(row);
      sessionStorage.setItem('planId', row.planId);
      this.$router.push('/channelAdPlanDetail')
    },
    //获取媒体列表
    getMediaList () {
      let params = {
        pageNum: this.current,
        pageSize: this.pageSize,
        communityName: this.filterParams.communityName,
        areaCode: this.filterParams.city.length ? String(this.filterParams.city[this.filterParams.city.length - 1]) : '',
        mac: this.filterParams.MAC,
        deviceName: this.filterParams.deviceName,
        deviceCode: this.filterParams.deviceCode,
        devStatus: this.filterParams.devStatus,
        devOnlineStatus: this.filterParams.devOnlineStatus,
      }
      for (let i in params) {
        params[i] ? '' : delete params[i]
      }
      api.getApi('/machine/getPrePlayMachineList', params).then(res => {
        if (res.data.code == 200) {
          this.total = res.data.data.total
          let result = res.data.data.list;
          this.mediaList = result.map((item, index) => {
            return {
              key: index,
              pointId: item.pointId,
              MAC: item.mac,
              deviceName: item.deviceName || '--',
              deviceCode: item.deviceCode || '--',
              TerminalType: item.version || '--',
              TerminalSystem: item.system || '--',
              province: item.province,
              city: item.city || '--',
              area: item.area || '--',
              companyName: item.companyName || '--',
              communityName: item.communityName || '--',
              mediaStatus: item.devStatus || '--',
              doorName: item.doorName || '--',
              devOnlineStatus: item.devOnlineStatus || '--',
            }
          })
          console.log('mediaList', this.mediaList)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //播放列表类型
    chooseAdType (e, type) {
      // console.log(e.target.value,type);
      let cloumn = [];
      if (e.target.value == 1) {
        cloumn = [
          {
            title: '计划名称',
            key: 'planName',
            scopedSlots: { customRender: 'planName' },
          }, {
            title: '开始时间',
            dataIndex: 'beginTime',
            key: 'beginTime'
          }, {
            title: '结束时间',
            dataIndex: 'endTime',
            key: 'endTime'
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ]
      } else {
        cloumn = [
          {
            title: '计划名称',
            key: 'planName',
            scopedSlots: { customRender: 'planName' },
          }, {
            title: '开始时间',
            dataIndex: 'beginTime',
            key: 'beginTime'
          }, {
            title: '结束时间',
            dataIndex: 'endTime',
            key: 'endTime'
          }, {
            title: '标签',
            dataIndex: 'conditionText',
            key: 'conditionText'
          }, {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
      if (type == 'play') {
        this.adType = e.target.value
        this.playColumns = cloumn
        this.getPlayList()
      } else {
        //广告包切换
        this.packageList.type = e.target.value
        this.packageList.columns = cloumn;
        if (e.target.value == 1) {
          this.packageList.list = this.packageList.accurate
        } else {
          this.packageList.list = this.packageList.shuffling
        }
      }

    },
    //查看物料
    showMaterial (item) {
      console.log(item);
      this.materialModal = true;
      this.getMaterialDetail(item.materialId)
    },
    //点击离线包
    showPackageList (item) {
      console.log(item);
      this.packageModal = true;
      this.packageList.title = item.packageVersion
      this.packageList.accurate = item.accurate
      this.packageList.shuffling = item.shuffling
      this.packageList.list = item.accurate

    },
    //获取播放列表
    getPlayList () {
      api.getApi('/machine/getPrePlayRecordList?pointId=' + this.pointId).then(res => {
        if (res.data.code == 200) {
          let arr = [];
          let result = res.data.data;
          arr = result.map((item, index) => {
            return {
              key: index,
              planId: item.planId,
              planName: item.planName,
              conditionText: item.conditionText,
              beginTime: timeFormat.toDateTime(item.beginTime),
              endTime: timeFormat.toDateTime(item.endTime),
              materialId: item.materialId
            };
          });
          this.playList = arr;
          console.log(this.playList);
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //物料更新记录列表
    GetMaterialUpdateList () {
      let info = {
        pointId: this.pointId,
        pageSize: 5,
        pageNum: this.updatePageNum,
      };
      api.getApi('/package/getMaterialUpdateList', info).then(res => {
        if (res.data.code == 200) {
          let arr = [];
          let result = res.data.data;
          this.updateTotal = result.total

          arr = result.list && result.list.map((item, index) => {
            let obj = {
              key: index,
              packageVersion: item.packageName,
              updateTime: timeFormat.toDateTime(item.updateTime),
              type: item.packageType == 1 ? '离线包' : '在线包',
              accurate: [],
              shuffling: [],
            };
            item.playRecordDetailList.map((data, dataIndex) => {
              data.key = dataIndex;
              if (data.priceStrategy == 1) {
                obj.accurate.push(data)
              } else {
                obj.shuffling.push(data)
              }
              return data;
            });
            return obj;
          });
          this.materialList = arr
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //获取城市选择
    getCityList () {
      api.getApi('/machine/getAreaList').then(res => {
        if (res.data.code == 200) {
          let areaList = []
          for (let firstKey of res.data.data) {
            let firstObj = {
              value: firstKey.key,
              label: firstKey.value,
              children: []
            }
            for (let secondKey of firstKey.children) {
              let secondObj = {
                value: secondKey.key,
                label: secondKey.value,
                children: []
              }
              for (let threeKey of secondKey.children) {
                secondObj.children.push({
                  value: threeKey.key,
                  label: threeKey.value,
                })
              }
              firstObj.children.push(secondObj)
            }
            areaList.push(firstObj)
          }
          // console.log('areaList',areaList)
          this.citySource = areaList
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //获取物料详情
    getMaterialDetail (id) {
      api.getApi('/material/detail/' + id).then(res => {
        if (res.data.code == 200) {
          this.materialInfo = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.readyplay_list {
  position: absolute;
  right: 32px;
  top: 120px;
}

.readyplay_list span {
  font-size: 14px;
  vertical-align: middle;
  cursor: pointer;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.ant-col-8 .ant-input,
.ant-col-8 .ant-cascader-picker {
  width: 90%;
}

.img-mask img {
  width: 100%;
  height: 100%;
}

.img-mask video,
.video-box video {
  width: 100%;
}

.play-modal .radio-wrap {
  text-align: center;
  margin-bottom: 16px;
}

.page-wrap {
  float: unset;
  text-align: right;
}

.material-box {
  width: 264px;
  height: 500px;
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url("../../../public/images/material.png") no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 4px 4px;
  position: relative;
}

.material-box .img-mask,
.material-box .video-mask {
  width: 222px;
  height: 160px;
  /*border: 1px solid #000;*/
  border-radius: 4px;
  cursor: pointer;
}

.material-box.half-screen-mask {
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url("../../../public/images/half-material.png") no-repeat;
}

.material-box.full-screen-mask .img-mask {
  height: 340px;
}

.material-box.full-screen-mask {
  margin: 0 auto;
  background-size: 264px 500px !important;
  background: url("../../../public/images/fullMaterial.png") no-repeat;
}

.material-box-wrap {
  display: flex;
  justify-content: space-around;
}
</style>
